import { render } from "./AnnotationToolViewingModeControls.vue?vue&type=template&id=a47658a4&scoped=true"
import script from "./AnnotationToolViewingModeControls.vue?vue&type=script&lang=js"
export * from "./AnnotationToolViewingModeControls.vue?vue&type=script&lang=js"

import "./AnnotationToolViewingModeControls.vue?vue&type=style&index=0&id=a47658a4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a47658a4"]])

export default __exports__